// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../domain/repo/CrmRepoManager.bs.js";
import * as Navbar$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as NewCampaignModal from "./newCampaign/NewCampaignModal.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as Caml_js_exceptions from "../../../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as SurgeTableComponent from "./surgeTable/SurgeTableComponent.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var CampaignLoaderConfig = {};

var CampaignLoaderComponent = LoaderComponent$Catalyst.LoaderComponent(CampaignLoaderConfig);

function isUrlGeoRegionIdValid(currentGeoRegionId, geoRegions) {
  return List.exists((function (geoRegion) {
                return geoRegion.id === currentGeoRegionId;
              }), geoRegions);
}

function getCurrentGeoRegionDetails(currentGeoRegionId, geoRegions) {
  return List.find((function (geoRegion) {
                return geoRegion.id === currentGeoRegionId;
              }), geoRegions);
}

function getNavbarActions(dispatch, action) {
  return {
          hd: {
            label: {
              TAG: /* Text */0,
              _0: "New Campaign"
            },
            on_select_cb: (function (param) {
                return Curry._1(dispatch, action);
              }),
            icon: undefined
          },
          tl: /* [] */0
        };
}

function SurgeDashboard(Props) {
  var geoRegionId = Props.geoRegionId;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            return {
                    showModal: !state.showModal,
                    isURLValid: state.isURLValid,
                    vehicleTypes: state.vehicleTypes,
                    geoRegions: state.geoRegions,
                    zones: state.zones
                  };
          }
          switch (action.TAG | 0) {
            case /* UpdateURLValidityStatus */0 :
                return {
                        showModal: state.showModal,
                        isURLValid: action._0,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: state.geoRegions,
                        zones: state.zones
                      };
            case /* FetchGeoRegionTypes */1 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: {
                          TAG: /* Loading */0,
                          _0: action._0
                        },
                        zones: state.zones
                      };
            case /* OnGeoRegionsFetched */2 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: {
                          TAG: /* Live */1,
                          _0: action._0
                        },
                        zones: state.zones
                      };
            case /* OnGeoRegionsFetchError */3 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: {
                          TAG: /* Error */2,
                          _0: action._0
                        },
                        zones: state.zones
                      };
            case /* FetchVehicleTypes */4 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: {
                          TAG: /* Loading */0,
                          _0: action._0
                        },
                        geoRegions: state.geoRegions,
                        zones: state.zones
                      };
            case /* OnVehicleTypesFetched */5 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: {
                          TAG: /* Live */1,
                          _0: action._0
                        },
                        geoRegions: state.geoRegions,
                        zones: state.zones
                      };
            case /* OnVehicleTypesFetchError */6 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: {
                          TAG: /* Error */2,
                          _0: action._0
                        },
                        geoRegions: state.geoRegions,
                        zones: state.zones
                      };
            case /* FetchZones */7 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: state.geoRegions,
                        zones: {
                          TAG: /* Loading */0,
                          _0: action._0
                        }
                      };
            case /* OnZonesFetched */8 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: state.geoRegions,
                        zones: {
                          TAG: /* Live */1,
                          _0: action._0
                        }
                      };
            case /* OnZonesFetchError */9 :
                return {
                        showModal: state.showModal,
                        isURLValid: state.isURLValid,
                        vehicleTypes: state.vehicleTypes,
                        geoRegions: state.geoRegions,
                        zones: {
                          TAG: /* Error */2,
                          _0: action._0
                        }
                      };
            
          }
        }), {
        showModal: false,
        isURLValid: true,
        vehicleTypes: /* Init */0,
        geoRegions: /* Init */0,
        zones: /* Init */0
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* FetchGeoRegionTypes */1,
                _0: undefined
              });
          
        }), []);
  React.useEffect((function () {
          var SurgeRepo = CrmRepoManager.getSurgeRepo(undefined);
          var _geoRegions = state.geoRegions;
          if (typeof _geoRegions !== "number") {
            switch (_geoRegions.TAG | 0) {
              case /* Loading */0 :
                  ApiUtils$Catalyst.handleAPIRequest((function (param) {
                          return Curry._1(SurgeRepo.fetchGeoRegions, country);
                        }), (function (geoRegions) {
                          return Curry._1(dispatch, {
                                      TAG: /* OnGeoRegionsFetched */2,
                                      _0: geoRegions
                                    });
                        }), (function (message) {
                          return Curry._1(dispatch, {
                                      TAG: /* OnGeoRegionsFetchError */3,
                                      _0: message
                                    });
                        }));
                  break;
              case /* Live */1 :
                  if (isUrlGeoRegionIdValid(geoRegionId, _geoRegions._0)) {
                    Curry._1(dispatch, {
                          TAG: /* FetchZones */7,
                          _0: undefined
                        });
                  } else {
                    Curry._1(dispatch, {
                          TAG: /* UpdateURLValidityStatus */0,
                          _0: false
                        });
                  }
                  break;
              case /* Error */2 :
                  break;
              
            }
          }
          
        }), [state.geoRegions]);
  React.useEffect((function () {
          var SurgeRepo = CrmRepoManager.getSurgeRepo(undefined);
          var _data = state.zones;
          if (typeof _data !== "number") {
            switch (_data.TAG | 0) {
              case /* Loading */0 :
                  ApiUtils$Catalyst.handleAPIRequest((function (param) {
                          return Curry._2(SurgeRepo.fetchZones, geoRegionId, country);
                        }), (function (data) {
                          return Curry._1(dispatch, {
                                      TAG: /* OnZonesFetched */8,
                                      _0: data
                                    });
                        }), (function (message) {
                          return Curry._1(dispatch, {
                                      TAG: /* OnZonesFetchError */9,
                                      _0: message
                                    });
                        }));
                  break;
              case /* Live */1 :
                  Curry._1(dispatch, {
                        TAG: /* FetchVehicleTypes */4,
                        _0: undefined
                      });
                  break;
              case /* Error */2 :
                  break;
              
            }
          }
          
        }), [state.zones]);
  React.useEffect((function () {
          var SurgeRepo = CrmRepoManager.getSurgeRepo(undefined);
          var _data = state.vehicleTypes;
          if (typeof _data !== "number" && _data.TAG === /* Loading */0) {
            ApiUtils$Catalyst.handleAPIRequest((function (param) {
                    return Curry._2(SurgeRepo.fetchVehicleTypes, geoRegionId, country);
                  }), (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* OnVehicleTypesFetched */5,
                                _0: data
                              });
                  }), (function (message) {
                    return Curry._1(dispatch, {
                                TAG: /* OnVehicleTypesFetchError */6,
                                _0: message
                              });
                  }));
          }
          
        }), [state.vehicleTypes]);
  var _data = state.geoRegions;
  var tmp;
  if (typeof _data === "number") {
    tmp = React.createElement("div", undefined, "Init...");
  } else {
    switch (_data.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {
                text: "Fetching Georegions ..."
              });
          break;
      case /* Live */1 :
          var geoRegions = _data._0;
          if (state.isURLValid) {
            var _data$1 = state.zones;
            if (typeof _data$1 === "number") {
              tmp = React.createElement("div", undefined, "Init...");
            } else {
              switch (_data$1.TAG | 0) {
                case /* Loading */0 :
                    try {
                      var geoRegion = getCurrentGeoRegionDetails(geoRegionId, geoRegions);
                      var name = geoRegion.name;
                      tmp = React.createElement(LoadingViewComponent$Catalyst.make, {
                            text: "Fetching zones for " + (name + " ...")
                          });
                    }
                    catch (raw_exn){
                      var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                      if (exn.RE_EXN_ID === "Not_found") {
                        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                              error: ErrorUtils$Catalyst.getDefaultErrorEntity("Please enter a valid geolocation Id", undefined, undefined)
                            });
                      } else {
                        throw exn;
                      }
                    }
                    break;
                case /* Live */1 :
                    var zones = _data$1._0;
                    var _data$2 = state.vehicleTypes;
                    if (typeof _data$2 === "number") {
                      tmp = React.createElement("div", undefined, "Init...");
                    } else {
                      switch (_data$2.TAG | 0) {
                        case /* Loading */0 :
                            try {
                              var geoRegion$1 = getCurrentGeoRegionDetails(geoRegionId, geoRegions);
                              var name$1 = geoRegion$1.name;
                              tmp = React.createElement(LoadingViewComponent$Catalyst.make, {
                                    text: "Fetching Vehicle Types for " + (name$1 + " ...")
                                  });
                            }
                            catch (raw_exn$1){
                              var exn$1 = Caml_js_exceptions.internalToOCamlException(raw_exn$1);
                              if (exn$1.RE_EXN_ID === "Not_found") {
                                tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                      error: ErrorUtils$Catalyst.getDefaultErrorEntity("Please enter a valid geolocation Id", undefined, undefined)
                                    });
                              } else {
                                throw exn$1;
                              }
                            }
                            break;
                        case /* Live */1 :
                            var vehicleTypes = _data$2._0;
                            var SurgeRepo = CrmRepoManager.getSurgeRepo(undefined);
                            tmp = React.createElement(CampaignLoaderComponent.make, {
                                  fetchData: (function (param) {
                                      return Curry._2(SurgeRepo.fetchCampaigns, geoRegionId, country);
                                    }),
                                  loadingView: (function (param) {
                                      try {
                                        var geoRegion = getCurrentGeoRegionDetails(geoRegionId, geoRegions);
                                        var name = geoRegion.name;
                                        return React.createElement(LoadingViewComponent$Catalyst.make, {
                                                    text: "Fetching campaigns for " + (name + " ...")
                                                  });
                                      }
                                      catch (raw_exn){
                                        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                                        if (exn.RE_EXN_ID === "Not_found") {
                                          return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                                      error: ErrorUtils$Catalyst.getDefaultErrorEntity("Please enter a valid geolocation Id", undefined, undefined)
                                                    });
                                        }
                                        throw exn;
                                      }
                                    }),
                                  renderView: (function (data, refreshView) {
                                      return React.createElement("div", undefined, React.createElement(Navbar$Catalyst.make, {
                                                      title: "Surge Dashboard",
                                                      actions: getNavbarActions(dispatch, /* ToggleModal */0)
                                                    }), React.createElement(SurgeTableComponent.make, {
                                                      campaigns: data,
                                                      refreshView: refreshView
                                                    }), state.showModal ? React.createElement(NewCampaignModal.make, {
                                                        onRefresh: refreshView,
                                                        onToggle: (function (param) {
                                                            return Curry._1(dispatch, /* ToggleModal */0);
                                                          }),
                                                        vehicleTypes: vehicleTypes,
                                                        geoRegion: getCurrentGeoRegionDetails(geoRegionId, geoRegions),
                                                        zones: zones
                                                      }) : null);
                                    })
                                });
                            break;
                        case /* Error */2 :
                            tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                  error: _data$2._0
                                });
                            break;
                        
                      }
                    }
                    break;
                case /* Error */2 :
                    tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                          error: _data$1._0
                        });
                    break;
                
              }
            }
          } else {
            tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: ErrorUtils$Catalyst.getDefaultErrorEntity("Please enter a valid geolocation Id", undefined, undefined)
                });
          }
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: _data._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "surgeDasboard__home"
            }, tmp);
}

var make = SurgeDashboard;

export {
  CampaignLoaderConfig ,
  CampaignLoaderComponent ,
  isUrlGeoRegionIdValid ,
  getCurrentGeoRegionDetails ,
  getNavbarActions ,
  make ,
  
}
/* CampaignLoaderComponent Not a pure module */
